import React from 'react'
import styled from 'styled-components'
import Fade from "react-reveal"

export default function Macbook({ text, img, list = [], side = "left", children }) {
    return (
        <MacbookStyled side={side}>
            <div className='container'>
                {children}
                <p>{text}</p>
                <div className={`macbook-main ${side === "right" && "right"}`}>
                    <Fade bottom>
                        <div className='macbook-img'>
                            <img src={img} alt="macbook" />
                        </div>
                    </Fade>
                    <div className='macbook-list'>
                        {
                            list.map((item) => (
                                <div className='macbook-item' key={item?.id}>
                                    {item.icon}
                                    <div>
                                        <h3>{item.title}</h3>
                                        <p>{item.text}</p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </MacbookStyled>
    )
}

const MacbookStyled = styled.div`
    margin-top: 100px;

    .macbook-main{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 50px;

        &.right{
            flex-direction: row-reverse;
            .macbook-list{
                gap: 50px;
            }
        }

        .macbook-img{
            width: 60%;

            img{
                width: 100%;
            }
        }
        .macbook-list{
                width: 30%;
                display: flex;
                flex-direction: column;
                gap: 25px;

                .macbook-item{
                        display: flex;
                        gap:20px;

                        h3{
                            font-weight: 600;
                            font-size: 24px;
                            line-height: 33px;
                        }

                        p{
                            line-height: 24px;
                            margin-top: 5px;
                        }
                    }
            }
            @media (max-width:992px) {
                flex-direction: column-reverse;
                &.right{
                    flex-direction: column-reverse;
                    .macbook-list{
                        gap: 20px;
                    }
                }
                .macbook-img{
                    width: 100%;
                    margin-top: 20px;
                }
                .macbook-list{
                    width: 100%;
                }
            }
        @media (max-width: 576px) {
            .macbook-list{
                .macbook-item{
                    h3{
                        font-size: 16px;
                        line-height: 22px;
                    }
                    p{
                        font-size: 12px;
                        line-height: 18px;
                    }
                }
            }
        }
    }

`
